import type { IPartnerSettings } from '.'

export const BmwFs: IPartnerSettings = {
  partner: 'BMWFS',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://broker.cebia.cz/test',
    prep: 'https://broker.cebia.cz/prep',
    production: 'https://broker.cebia.cz/prod'
  },
  hosts: [
    'broker-new.cebia.cz'
    // , 'localhost:44470'
  ]
}